<template>
  <v-dialog v-model="isOpen" max-width="620" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon left color="indigo">mdi-earth</v-icon>
        Traductions de {{ fieldName }}
        <v-spacer />
        <v-btn icon aria-label="Fermer" :disabled="saving || deleting" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-alert v-if="error" type="error" text dense>{{ error }}</v-alert>
        <v-progress-linear v-if="loading" indeterminate color="indigo" class="mb-4" />
        <v-textarea :value="sourceValue" label="Texte d'origine" rows="2" readonly outlined dense />
        <v-select v-model="locale" :items="locales" label="Langue" item-text="text" item-value="value" outlined dense />
        <v-textarea v-model="translationValue" :label="localeLabel ? 'Traduction en ' + localeLabel : 'Traduction'" :disabled="!locale || loading" rows="4" outlined auto-grow />
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="hasStoredTranslation" color="error" text :loading="deleting" :disabled="saving" @click="removeTranslation"><v-icon left small>mdi-delete-outline</v-icon>Supprimer</v-btn>
        <v-spacer />
        <v-btn text :disabled="saving || deleting" @click="close">Annuler</v-btn>
        <v-btn color="indigo" dark :loading="saving" :disabled="!locale || loading || deleting" @click="saveTranslation">Enregistrer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FieldTranslationsDialog',
  props: {
    value: { type: Boolean, default: false },
    fieldId: { type: [String, Number], required: true },
    lineId: { type: [String, Number], required: true },
    fieldName: { type: String, default: '' },
    sourceValue: { default: '' }
  },
  data() {
    return {
      locale: 'en', translationValue: '', translations: {},
      loading: false, saving: false, deleting: false, error: '',
      locales: [
        { text: 'Anglais', value: 'en' }, { text: 'Espagnol', value: 'es' },
        { text: 'Allemand', value: 'de' }, { text: 'Italien', value: 'it' },
        { text: 'Chinois simplifié', value: 'zh-CN' }
      ]
    }
  },
  computed: {
    isOpen: { get() { return this.value }, set(value) { this.$emit('input', value) } },
    localeLabel() { const item = this.locales.find(locale => locale.value === this.locale); return item ? item.text.toLowerCase() : '' },
    hasStoredTranslation() { return !!this.locale && Object.prototype.hasOwnProperty.call(this.translations, this.locale) }
  },
  watch: {
    value(open) { if (open) this.loadTranslations() },
    locale() { this.translationValue = this.translations[this.locale] || '' }
  },
  methods: {
    identity() { return { field_id: this.fieldId, ligne_id: this.lineId } },
    async loadTranslations() {
      this.loading = true; this.error = ''
      try {
        const response = await this.API({ type: 'post', url: '/engine/traductions/list', params: this.identity() })
        const payload = response && response.data
        this.translations = payload && payload.translations && typeof payload.translations === 'object' ? payload.translations : {}
        this.translationValue = this.translations[this.locale] || ''
      } catch (error) { this.error = 'Impossible de charger les traductions.' }
      finally { this.loading = false }
    },
    async saveTranslation() {
      this.saving = true; this.error = ''
      try {
        await this.API({ type: 'put', url: '/engine/traductions', params: { ...this.identity(), locale: this.locale, valeur: this.translationValue } })
        this.$set(this.translations, this.locale, this.translationValue)
        this.$toast.success('Traduction enregistrée')
      } catch (error) { this.error = "Impossible d'enregistrer la traduction." }
      finally { this.saving = false }
    },
    async removeTranslation() {
      this.deleting = true; this.error = ''
      try {
        await this.API({ type: 'post', url: '/engine/traductions/delete', params: { ...this.identity(), locale: this.locale } })
        this.$delete(this.translations, this.locale); this.translationValue = ''
        this.$toast.success('Traduction supprimée')
      } catch (error) { this.error = 'Impossible de supprimer la traduction.' }
      finally { this.deleting = false }
    },
    close() { this.isOpen = false }
  }
}
</script>
